import React, { useState, useEffect } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { InfoIcon } from "lucide-react";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/components/ui/tooltip";
import Setup_done from './Setup_Done';
import Price_request_pop from './Price_request_pop';
import Price_setup_pop from './Price_setup_pop';
import { userService } from "../../_services";

function Pricing_tool({ profileData, getPricing }) {
    const profile = profileData[0] || {};

    const [requestBox, setRequestBox] = useState(false);
    const [setupModel, setSetupModel] = useState(false);
    const [pricingToolRequestStatus, setPricingToolRequestStatus] = useState(profile.pricingToolRequestStatus || '');
    const [adminRequestforTool, setAdminRequestforTool] = useState(profile.adminApproval || false);
    const [groupNumber, setGroupNumber] = useState(profile.groupNumber || '');
    const [subDomain, setSubDomain] = useState(profile.subDomain || '');
    const [userData, setUserData] = useState('');

    useEffect(() => {
        try {
            const decoded = window.atob(localStorage.getItem('ajs_user_id'));
            setUserData(decoded);
        } catch (error) {
            console.error('Error getting user data:', error);
        }
        try {
            localStorage.setItem('subDomain', profile.subDomain || '');
        } catch (error) {
            console.error('Error setting subDomain:', error);
        }
    }, [profile.subDomain]);

    const toggleRequestPop = (e) => {
        e.stopPropagation();
        setRequestBox(prev => !prev);
    };

    const submitRequest = () => {
        try {
            getPricingToolUpdate(userData.split(':')[0], '', '', 'Request');
        } catch (error) {
            console.error('Error submitting request:', error);
        }
        setRequestBox(false);
    };

    const toggleSetupModel = (e) => {
        if (e) e.stopPropagation();
        setSetupModel(prev => !prev);
    };

    const submit_setup = (_subDomain, _groupNumber, _actionType) => {
        setGroupNumber(_groupNumber);
        setSubDomain(_subDomain);
        setPricingToolRequestStatus(_actionType);
        setSetupModel(false);
        getPricing();
    };

    const getPricingToolUpdate = (UserId, SubDomain, GroupNumber, Task_Name) => {
        try {
            userService.PricingToolInitialStatus(UserId, SubDomain, GroupNumber, Task_Name)
                .then(apidata => {
                    if (apidata.length > 0) {
                        setPricingToolRequestStatus(apidata[0].requestStatus);
                    }
                });
        } catch (error) {
            console.error('Error getting pricing tool update:', error);
        }
    };

    const showemail = userService.getemail();
    const tooltipText = "Integrate the pricing tool you see on our homepage into your own website. This will be linked to your unique group number.";
    const ptStatus = profile.pricingToolRequestStatus;

    const TooltipIcon = () => (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <Button type="button" size="icon" variant="ghost" className="h-6 w-6 text-muted-foreground hover:text-foreground">
                        <InfoIcon className="h-4 w-4" />
                    </Button>
                </TooltipTrigger>
                <TooltipContent className="max-w-xs">
                    <p className="text-sm">{tooltipText}</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );

    return (
        <Card className="h-full">
            <CardContent className="p-6 h-full flex flex-col justify-center">
                {/* Rejected Status */}
                {ptStatus === "Rejected" && (
                    <div className="space-y-3">
                        <div className="flex items-center gap-2">
                            <h3 className="text-xl font-semibold text-foreground">Pricing Tool</h3>
                        </div>
                        <div className="p-4 bg-destructive/10 border border-destructive/30 rounded-md">
                            <p className="text-sm text-destructive">
                                Your request has been rejected. Please{' '}
                                <a href={"mailto:" + showemail} className="text-accent hover:no-underline hover:text-foreground font-medium">
                                    contact us
                                </a>
                                {' '}for more details
                            </p>
                        </div>
                    </div>
                )}

                {/* Requested or Empty Status */}
                {(ptStatus === "Requested" || ptStatus === "") && (
                    <div className="flex items-center justify-between gap-4 flex-wrap">
                        <div className="flex items-center gap-2">
                            <h3 className="text-xl font-semibold text-foreground">Pricing Tool</h3>
                            <TooltipIcon />
                        </div>
                        <div className="flex flex-wrap gap-3">
                            {userService.Check_Null_Empty(pricingToolRequestStatus) ? (
                                <Button variant="outline" onClick={toggleRequestPop}>
                                    Click to Request Pricing Tool
                                </Button>
                            ) : !adminRequestforTool ? (
                                <Badge variant="warning">Pending</Badge>
                            ) : null}
                            <Button
                                variant="secondary"
                                onClick={toggleSetupModel}
                                disabled={!adminRequestforTool}
                            >
                                Click to Setup
                            </Button>
                        </div>
                    </div>
                )}

                {/* Approved but Not Setup */}
                {((ptStatus === "Approved" && profile.subDomain === "") ||
                    (ptStatus === "Submitted" && profile.isActive === false)) && (
                        <div className="flex items-center justify-between gap-4 flex-wrap">
                            <div className="flex items-center gap-2">
                                <h3 className="text-xl font-semibold text-foreground">Pricing Tool</h3>
                                <TooltipIcon />
                            </div>
                            <Button
                                variant="secondary"
                                onClick={toggleSetupModel}
                                disabled={!adminRequestforTool}
                            >
                                Click to Setup
                            </Button>
                        </div>
                    )}

                {/* Setup Complete */}
                {ptStatus === "Submitted" && profile.subDomain !== "" && profile.isActive === true && (
                    <Setup_done groupNumber={groupNumber} subDomain={profile.subDomain} />
                )}

                {/* Modals */}
                {requestBox && (
                    <Price_request_pop
                        CloseRequestPopUp={toggleRequestPop}
                        submit_Request={submitRequest}
                    />
                )}
                {setupModel && (
                    <Price_setup_pop
                        submit_Setup_Detail={submit_setup}
                        close_setup={toggleSetupModel}
                        titleText="Setup Pricing Tool"
                        detailText="Setup or edit your unique web and mobile app pricing tool link by selecting the group number to use below"
                        popupName="createPricingTool"
                        btnText="Create"
                    />
                )}
            </CardContent>
        </Card>
    );
}

export default Pricing_tool;

